import React from "react";

import styled from "styled-components";
import {debounce} from "utils";

import m from "definedMessages";


import { Form, InputGroup } from "rsuite";

export default ({
    filter,
    onChangeFilter,
    formatMessage
}) => {
    return (
        <StyledForm
            formDefaultValue={filter}
            onChange={debounce((value) => {
                onChangeFilter(value);
            }, 500)}
        >
            <StyledFormGroup>
                <InputGroup inside>
                    <StyledFormControl
                        placeholder={formatMessage(m.rangeOrNumber)}
                        name="filter_phone"
                        errorPlacement="topRight"
                    />
                </InputGroup>
            </StyledFormGroup>
        </StyledForm>
    )
}
const StyledForm = styled(Form)`
    && {
        width: 100%;
        display: flex;
    }

    .rs-form-control-wrapper {
        width: auto;
        margin-right: 20px;
    }
`;

const StyledAddon = styled(InputGroup.Addon)`
    &&&& {
        position: relative;
        padding: 0;
    }
`;

const StyledFormControl = styled(Form.Control)`
    && {
        width: 100%;
        min-width: 300px;
        max-width: 320px;
        overflow: hidden;
    }
`;

const StyledFormGroup = styled(Form.Group)`
    && {
        display: flex;
        align-items: center;

        .rs-control-label {
            margin-right: 10px;
            margin-bottom: 0px;
        }
    }
`;